import {trpc} from '@common-web/lib/trpc';
import {Badge} from '@common-web/components/ui/badge';
import {Skeleton} from '@common-web/components/ui/skeleton';
import {formatDateTime} from '@common/lib/utils';
import {AUDIT_ACTION_LABELS} from './utils';

export function RoleAuditLog({roleId}: {roleId: string}) {
  const {data, isLoading} = trpc.internal.roles.audit.list.useQuery({
    roleId,
    page: 1,
    pageSize: 25,
  });

  if (isLoading) {
    return <Skeleton className='h-32 w-full' />;
  }

  if (!data || data.entries.length === 0) {
    return <p className='text-sm text-brand-gray italic'>No activity recorded yet.</p>;
  }

  return (
    <div className='space-y-2'>
      {data.entries.map((entry) => (
        <div key={entry.id} className='border rounded-md p-3 bg-gray-50/50'>
          <div className='flex items-center justify-between mb-1'>
            <Badge variant='outline' className='text-xs'>
              {AUDIT_ACTION_LABELS[entry.action] ?? entry.action}
            </Badge>
            <span className='text-xs text-brand-gray'>{formatDateTime(entry.occurredAt)}</span>
          </div>
          <p className='text-sm text-brand-navy'>
            {entry.actor?.name ?? entry.actor?.email ?? entry.actorUserId}
          </p>
        </div>
      ))}
    </div>
  );
}
